import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../stores/hook';
import { getPackInfoById } from '../../../functions/fetchGetStarted';
import { setNowEStatus } from '../GetStartedSlice';
import translations from '../../../../text/get-started-translations.json';
import language from '../../../../utils/LanguageSettings';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import gfm from 'remark-gfm';
import closeImage from '../../../../images/icon/icon-close.svg';
import nowELogo from '../../../../images/icon/nowe_logo.svg';
import eTvArround from '../../../../images/icon/e-tv-arrow.svg';
import nowTvLogo from  '../../../../images/icon/nowtv-logo.svg';
import nowEChecked from '../../../../images/icon/nowe-checked.svg'
import nowTvChecked from '../../../../images/icon/nowtv-checked.svg'
import minus from '../../../../images/icon/icon-minus.svg'

interface NowEModalProps {
}

const NowEModal: React.FC<NowEModalProps> = () => {
    const pageTranslations = translations[language];
    const [isShow, setIsShow] = useState<any>(null);
    const isNowEStatus = useAppSelector((state) => state.getStarted.isNowEStatus);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (isNowEStatus) {
            setIsShow(true);
        }
    }, [isNowEStatus]);

    const handleClick = () => {
        dispatch(setNowEStatus(false));
        setIsShow(false);
    }

    return (
            <>  

        <div className={isShow ? "modal-wrapper likenowe-modal show" : "modal-wrapper likenowe-modal"}>
            <div className="modal-dialog">
              <div className="modal-content-wrapper md">
                <div className="close-wrap">
                    <div className="close-btn"><button className="close-modal" onClick={() => {handleClick()}}>{pageTranslations.Close} <img src={closeImage} alt="Close icon" /></button></div>
                </div>
                <div className="alert-wrapper likenowe-wrapper">
                        <h3>{translations[language].noweTitle}</h3>
                        <p>
                            <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]} components={{p: React.Fragment,}}>{translations[language].noweModalMessage}</ReactMarkdown>
                        </p>
                        <div className="e-to-TV">
                            <div className="nowe-logo"><img src={nowELogo} alt="" /></div> 
                            <div className="arrow"><img src={eTvArround} alt="" /></div>
                            <div className="nowtv-logo"><img src={nowTvLogo} alt="" /></div> 
                        </div> 
                        <div className="comparison-table-wrapper">
                            <table>
                                <tbody><tr>
                                    <td>
                                        <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]} components={{p: React.Fragment,}}>{translations[language].noweTableMessage1}</ReactMarkdown>
                                    </td>
                                    <td> <img src={nowEChecked} alt="" /></td>
                                    <td> <img src={nowTvChecked} alt="" /></td>
                                </tr>

                                <tr>
                                    <td>{translations[language].noweTableMessage2}</td>
                                    <td> <img src={nowEChecked} alt="" /></td>
                                    <td> <img src={nowTvChecked} alt="" /></td>
                                </tr>

                                <tr>
                                    <td>{translations[language].noweTableMessage3}</td>
                                    <td> <img src={minus} alt="" /> </td>
                                    <td>
                                        <img src={nowTvChecked} alt="" />
                                        <ul>
                                        <li>{translations[language]['noweTableMessage3-1']}</li>
                                        <li>{translations[language]['noweTableMessage3-2']}</li>
                                        <li>{translations[language]['noweTableMessage3-3']}</li>
                                        <li>{translations[language]['noweTableMessage3-4']}</li>
                                        <li>{translations[language]['noweTableMessage3-5']}</li>
                                        </ul>
                                    </td>
                                </tr>

                                <tr>
                                    <td>{translations[language].noweTableMessage4}</td>
                                    <td> <img src={minus} alt="" /> </td>
                                    <td>
                                        <img src={nowTvChecked} alt="" />
                                        <div><h4>{translations[language]['noweTableMessage4-h4']}</h4> <a href="/get-started-box" className="link arrow">{translations[language]['noweTableMessage4-h4-a']}</a> </div>
                                    </td>
                                </tr>

                            </tbody></table>
                        </div>
                        <div className="continue"><button onClick={() => {handleClick()}} className="close-modal link arrow">{translations[language].noweFooter}</button></div>
                    </div>
              </div>
            </div>
        </div>
    </>
    );
}
export default NowEModal;